export class CostReviewFireEnUsOutsidePurchases {
  specialFabricationItems!: number;
  heatersRequired!: number;
  thirdPartyMaterialsIdentified!: number;
  supplierPartNumbers!: number;
  outsidePurchaseSystems!: number;
  ifYesRequireManufacturer!: number;
  isOutsidePurchasesApplicable!: boolean;
}
